import colormap from "colormap";
import npyjs from "npyjs";
import { Parsed } from "npyjs";
//import zlib from "zlib";
import { DoseDatatype, DoseMapMessage,MinMaxPair,TiledDoseMapImage } from "../BD21DataStream";
import jszip from "jszip";

import rawDoseMapFile from './dose.npy'; //'./dp4dr8.npz';
import rawDoseStdMapFile from './dose_std.npy'; //'./dp4dr8.npz';
import rawNPZFile from './dp4dr8.npz'
import { ScaleOverride } from "../components/DoseMapDisplay";
export enum DoseAnalysisType {DIFFERENCE=1, ZSCORE=2, COMBINE=3};

//type Parsed = { dtype: npyjs.dtype, data: nums,shape,fortranOrder: header.fortran_order}
/*
this.dtypes = {
    "<u1": {
        name: "uint8",
        size: 8,
        arrayConstructor: Uint8Array,
    },
    "|u1": {
        name: "uint8",
        size: 8,
        arrayConstructor: Uint8Array,
    },
    "<u2": {
        name: "uint16",
        size: 16,
        arrayConstructor: Uint16Array,
    },
    "|i1": {
        name: "int8",
        size: 8,
        arrayConstructor: Int8Array,
    },
    "<i2": {
        name: "int16",
        size: 16,
        arrayConstructor: Int16Array,
    },
    "<u4": {
        name: "uint32",
        size: 32,
        arrayConstructor: Int32Array,
    },
    "<i4": {
        name: "int32",
        size: 32,
        arrayConstructor: Int32Array,
    },
    "<u8": {
        name: "uint64",
        size: 64,
        arrayConstructor: BigUint64Array,
    },
    "<i8": {
        name: "int64",
        size: 64,
        arrayConstructor: BigInt64Array,
    },
    "<f4": {
        name: "float32",
        size: 32,
        arrayConstructor: Float32Array
    },
    "<f8": {
        name: "float64",
        size: 64,
        arrayConstructor: Float64Array
    },
};
*/

export class DoseMapUtility {

    static async loadDoseMapFile(){
        let n = new npyjs();
        const npyArray = await n.load(rawDoseMapFile)
        return npyArray
    }
    static async loadDoseStdMapFile(){
        let n = new npyjs();
        const npyArray = await n.load(rawDoseStdMapFile)
        return npyArray
    }
    //static async loadNPZFile(url: string): Promise<{ [key: string]: any }> {
    static async loadNPZFile(){
        const response = await fetch(rawNPZFile);
        const zipData = await response.arrayBuffer();
        const zip = await jszip.loadAsync(zipData);

        let npzData: { [key: string]: any } = {};

        for (const filename in zip.files) {
            if (filename.endsWith('.npy')) {
                console.log('loading'+filename);
                const file = zip.files[filename];
                const arrayBuffer = await file.async('arraybuffer');
                let npy = new npyjs();
                const { data, shape, dtype } = await npy.load(arrayBuffer);
                npzData[filename.replace('.npy', '')] = { data, shape, dtype };
            }
        }
        return npzData;
    }
    static async loadNPZFromBuffer(buffer:ArrayBuffer){
    //const arrayBuffer = await jszipFile.async('arraybuffer');
        const blob = new Blob([buffer]);
        const zip = await jszip.loadAsync(blob);
        let npzData: { [key: string]: any } = {};

        for (const filename in zip.files) {
            if (filename.endsWith('.npy')) {
                //console.log('loading '+filename);
                const file = zip.files[filename];
                const arrayBuffer = await file.async('arraybuffer');
                let npy = new npyjs();
                let npy_data = await npy.load(arrayBuffer);
                let data; //= npy_data.data;
                const shape = npy_data.shape;
                let dtype = npy_data.dtype;
                let fortran_order = npy_data.fortranOrder;
                if (fortran_order){
                    data = DoseMapUtility.flipMajorOrder(npy_data.data as Float64Array,shape)
                } else {
                    data = npy_data.data
                }
                //Convert to Float32
                const data32 = Float32Array.from(data as Float64Array);
                data = data32;
                dtype = "float32";
                //console.log(npy_data)
                npzData[filename.replace('.npy', '')] = { data, shape, dtype };
            }
        }

        return {npzData:npzData, blob:blob};;
    }

    static async loadNPZ(jszipFile:jszip.JSZipObject){
    //const arrayBuffer = await jszipFile.async('arraybuffer');
        const blob = await jszipFile.async('blob');
        const zip = await jszip.loadAsync(blob);
        let npzData: { [key: string]: any } = {};

        for (const filename in zip.files) {
            if (filename.endsWith('.npy')) {
                //console.log('loading '+filename);
                let file = zip.files[filename];
                const arrayBuffer = await file.async('arraybuffer');
                let npy = new npyjs();
                let npy_data = await npy.load(arrayBuffer);
                let data; //= npy_data.data;
                const shape = npy_data.shape;
                let dtype = npy_data.dtype;
                const fortran_order = npy_data.fortranOrder;
                if (fortran_order){
                    data = DoseMapUtility.flipMajorOrder(npy_data.data as Float64Array,shape)
                } else {
                    data = npy_data.data
                }
                //Convert to Float32
                const data32 = Float32Array.from(data as Float64Array);
                data = data32;
                dtype = "float32";

                //console.log(npy_data)
                npzData[filename.replace('.npy', '')] = { data, shape, dtype };
            }
        }

        return {npzData:npzData, blob:blob};;
    }
    // /Uint8Array|Uint16Array|Int8Array|Int16Array|Int32Array|BigUint64Array|BigInt64Array|Float32Array|Float64Array
    static flipMajorOrder(array:Float64Array, shape:number[]) {
        const newArray = new Float64Array(array.length);
        let rows = shape[0];
        let cols = shape[1];

        for (let i = 0; i < rows; i++) {
            for (let j = 0; j < cols; j++) {
                newArray[j * rows + i] = array[i * cols + j];
            }
        }

        return newArray;
    }

    static makeDoseMapMessageFromNpy(){
        console.log('makeDoseMapMessageFromNpy')
    }
    static UpdateDoseMapAnalysis(analysisType:DoseAnalysisType, messageA:DoseMapMessage, messageB:DoseMapMessage){
        console.log('UpdateDoseMapAnalysis')
        let regionListA:{[key:string]:TiledDoseMapImage} = {};
        if(messageA.regions !== null){
            for(let i = 0; i < messageA.regions.length; i++) {
                if(messageA.regions[i].uuid !== null){
                    regionListA[messageA.regions[i].uuid!]=messageA.regions[i];
                }
            }
        }
        let regionListB:{[key:string]:TiledDoseMapImage} = {};
        if(messageB.regions !== null){
            for(let i = 0; i < messageB.regions.length; i++) {
                if(messageB.regions[i].uuid !== null){
                    regionListB[messageB.regions[i].uuid!]=messageB.regions[i];
                }
            }
        }

        const overlap = Object.keys(regionListA).filter(value => Object.keys(regionListB).includes(value));

        let dose_map_message:DoseMapMessage = { regions: [],
                                                time: null,
                                                lastUpdatedTime: null,
                                                manifest: messageA.manifest,
                                                displayScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                globalScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}}}

        let regionOverlap:TiledDoseMapImage[] = []
        overlap.forEach(geohash => {

            const maskMapA = regionListA[geohash].maskMap?.data as Float32Array;
            const maskMapB = regionListB[geohash].maskMap?.data as Float32Array;

            if(maskMapA !== undefined && maskMapB !== undefined){
                let maskMapAnalysis= new Float32Array(maskMapA.length);
                if(analysisType===DoseAnalysisType.DIFFERENCE || analysisType===DoseAnalysisType.ZSCORE){
                    let maskMapAnd= new Float32Array(maskMapA.length);
                    if(maskMapA !== undefined && maskMapB !== undefined){
                        for (let i = 0; i < maskMapA.length; i++) {
                            if(maskMapA[i]>0 && maskMapB[i]>0){
                                 maskMapAnd[i] = 1;
                            }else {
                                maskMapAnd[i] = 0;
                            }
                        }
                    }
                    maskMapAnalysis = maskMapAnd;
                } else if (analysisType===DoseAnalysisType.COMBINE){

                    let maskMapOr= new Float32Array(maskMapA.length);
                    if(maskMapA !== undefined && maskMapB !== undefined){
                        for (let i = 0; i < maskMapA.length; i++) {
                            if(maskMapA[i]>0 || maskMapB[i]>0){
                                 maskMapOr[i] = 1;
                            }else {
                                maskMapOr[i] = 0;
                            }
                        }
                    }
                    maskMapAnalysis = maskMapOr;
                }


                const thisRegionA = regionListA[geohash];
                const doseRawA = regionListA[geohash].doseRaw?.data as Float32Array;
                const doseRawB = regionListB[geohash].doseRaw?.data as Float32Array;
                const doseStdRawA = regionListA[geohash].doseStdRaw?.data as Float32Array;
                const doseStdRawB = regionListB[geohash].doseStdRaw?.data as Float32Array;

                let doseRawAnalysis = new Float32Array(doseRawA.length)

                if(analysisType===DoseAnalysisType.DIFFERENCE){
                    let doseRawDiff= new Float32Array(doseRawA.length);
                        if(doseRawA !== undefined && doseRawB !== undefined){
                            for (let i = 0; i < doseRawA.length; i++) {
                              doseRawDiff[i] = doseRawA[i] - doseRawB[i];
                            }
                        }
                    doseRawAnalysis = doseRawDiff;
                } else if (analysisType===DoseAnalysisType.ZSCORE){
                    let doseRawZScore= new Float32Array(doseRawA.length);
                        if(doseRawA !== undefined && doseRawB !== undefined && doseStdRawA !== undefined && doseStdRawB !== undefined){
                            for (let i = 0; i < doseRawA.length; i++) {
                              doseRawZScore[i] = (doseRawA[i] - doseRawB[i])/(Math.sqrt(doseStdRawA[i]*doseStdRawA[i]+doseStdRawB[i]*doseStdRawB[i]));
                            }
                        }
                    doseRawAnalysis = doseRawZScore;
                } else if (analysisType===DoseAnalysisType.COMBINE){
                    let doseRawCombined= new Float32Array(doseRawA.length);
                        if(doseRawA !== undefined && doseRawB !== undefined){
                            for (let i = 0; i < doseRawA.length; i++) {
                                if(maskMapA[i] > 0 && maskMapB[i] > 0 && doseStdRawA[i] > 0 && doseStdRawB[i] > 0){
                                    doseRawCombined[i] = (doseRawA[i]+doseRawB[i])/2.0;
                                    //doseRawCombined[i] = ((doseRawA[i]/doseStdRawA[i])+(doseRawB[i]/doseStdRawB[i]))*((1.0/doseStdRawA[i])+(1.0/doseStdRawB[i]));
                                } else if (maskMapA[i] > 0 && maskMapB[i] === 0 ) {
                                    doseRawCombined[i] = doseRawA[i];
                                } else if (maskMapA[i] === 0 && maskMapB[i] > 0 ) {
                                    doseRawCombined[i] = doseRawB[i];
                                } else {
                                    doseRawCombined[i] = 0;
                                }
                            }
                        }
                    doseRawAnalysis = doseRawCombined;
                }

                const doseMaxRawA = regionListA[geohash].doseMaxRaw?.data as Float32Array;
                const doseMaxRawB = regionListB[geohash].doseMaxRaw?.data as Float32Array;
                const doseMaxStdRawA = regionListA[geohash].doseMaxStdRaw?.data as Float32Array;
                const doseMaxStdRawB = regionListB[geohash].doseMaxStdRaw?.data as Float32Array;

                let doseMaxRawAnalysis = new Float32Array(doseMaxRawA.length)

                if(analysisType===DoseAnalysisType.DIFFERENCE){
                    let doseMaxRawDiff= new Float32Array(doseMaxRawA.length);
                    if(doseMaxRawA !== undefined && doseMaxRawB !== undefined){
                        for (let i = 0; i < doseMaxRawA.length; i++) {
                            doseMaxRawDiff[i] = doseMaxRawA[i] - doseMaxRawB[i];
                        }
                    }
                    doseMaxRawAnalysis = doseMaxRawDiff;
                } else if (analysisType===DoseAnalysisType.ZSCORE){
                    let doseMaxRawZScore= new Float32Array(doseMaxRawA.length);
                        if(doseMaxRawA !== undefined && doseMaxRawB !== undefined && doseMaxStdRawA !== undefined && doseMaxStdRawB !== undefined){
                            for (let i = 0; i < doseRawA.length; i++) {
                                doseMaxRawZScore[i] = (doseMaxRawA[i] - doseMaxRawB[i])/(Math.sqrt(doseMaxStdRawA[i]*doseMaxStdRawA[i]+doseMaxStdRawB[i]*doseMaxStdRawB[i]));
                            }
                        }
                    doseMaxRawAnalysis = doseMaxRawZScore;
                } else if (analysisType===DoseAnalysisType.COMBINE){
                    let doseMaxRawCombined= new Float32Array(doseMaxRawA.length);
                        if(doseMaxRawA !== undefined && doseMaxRawB !== undefined){
                            for (let i = 0; i < doseRawA.length; i++) {
                                if(maskMapA[i] > 0 && maskMapB[i] > 0 && doseMaxStdRawA[i] > 0 && doseMaxStdRawB[i] > 0){
                                    //doseMaxRawCombined[i] = ((doseMaxRawA[i]/doseMaxStdRawA[i])+(doseMaxRawB[i]/doseMaxStdRawB[i]))*((1.0/doseMaxStdRawA[i])+(1.0/doseMaxStdRawB[i]));
                                    doseMaxRawCombined[i] = Math.max(doseMaxRawA[i],doseMaxRawB[i]);
                                } else if (maskMapA[i] > 0 && maskMapB[i] === 0 ) {
                                    doseMaxRawCombined[i] = doseMaxRawA[i];
                                } else if (maskMapA[i] === 0 && maskMapB[i] > 0 ) {
                                    doseMaxRawCombined[i] = doseMaxRawB[i];
                                } else {
                                    doseMaxRawCombined[i] = 0;
                                }
                            }
                        }
                    doseMaxRawAnalysis = doseMaxRawCombined;
                }

                //console.log(doseRawDiff)
                let thisDoseRaw:Parsed = {dtype:"float32",data:doseRawAnalysis,shape:[500,500],fortranOrder:false};
                let thisDoseMaxRaw:Parsed = {dtype:"float32",data:doseMaxRawAnalysis,shape:[500,500],fortranOrder:false};
                let thisMaskMapRaw:Parsed = {dtype:"float32",data:maskMapAnalysis,shape:[500,500],fortranOrder:false};
                let thisDoseMapStdRaw:Parsed = {dtype:"float32",data:maskMapAnalysis,shape:[500,500],fortranOrder:false};
                let msg1 = DoseMapUtility.MakeDoseImageMasked(thisDoseRaw,thisMaskMapRaw,-2,2)
                let imageData1 = Buffer.from(msg1, 'base64');
                const binaryDoseMapData = imageData1 as unknown as string;
                let msg2 = DoseMapUtility.MakeDoseImageMasked(thisDoseMaxRaw,thisMaskMapRaw,-2,2)
                let imageData2 = Buffer.from(msg2, 'base64');
                const binaryDoseMaxData = imageData2 as unknown as string;

                let thisRegion:TiledDoseMapImage = {uuid: thisRegionA.uuid,
                                                    time: Date.now()/1000,
                                                    doseMap: binaryDoseMapData,
                                                    maxDoseMap: binaryDoseMaxData,
                                                    uncertMap: null,
                                                    doseRaw: thisDoseRaw,
                                                    doseMaxRaw: thisDoseMaxRaw,
                                                    maskMap: thisMaskMapRaw,
                                                    maskMax: thisMaskMapRaw,
                                                    dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                    swCorner: {lat:thisRegionA.swCorner.lat!,
                                                               lon:thisRegionA.swCorner.lon!},
                                                    neCorner: {lat:thisRegionA.neCorner.lat!,
                                                               lon:thisRegionA.neCorner.lon!}};

                //Calculate data statistics
                DoseMapUtility.updateDataStatisticsForRegion(thisRegion);

                regionOverlap.push(thisRegion)
                dose_map_message.regions!.push(thisRegion);
                if(thisRegion.time !== null && (dose_map_message.lastUpdatedTime === null || dose_map_message.lastUpdatedTime < thisRegion.time)){
                    dose_map_message.lastUpdatedTime = thisRegion.time;
                }
            }
        });


        //COMBINE
        if(analysisType===DoseAnalysisType.COMBINE){
            //other tiles without overlap
            const concat = Object.keys(regionListA).concat(Object.keys(regionListB));
            const all_region = new Set(concat);
            //const all_other_region = Object.keys(set).filter(value => !Object.keys(overlap).includes(value));

            all_region.forEach(geohash => {

                let thisRegionA = regionListA[geohash];
                let thisRegionB = regionListB[geohash];

                let doseRaw:Float32Array;
                let doseStdRaw:Float32Array;
                let doseMaxRaw:Float32Array;
                let doseMaxStdRaw:Float32Array;
                let maskMap:Float32Array;
                let thisRegionCombined;
                let thisRegionUuid:string|null;

                let process_this_region = true;
                if(thisRegionA && !thisRegionB){
                    doseRaw = regionListA[geohash].doseRaw?.data as Float32Array;
                    doseStdRaw = regionListA[geohash].doseStdRaw?.data as Float32Array;
                    doseMaxRaw = regionListA[geohash].doseMaxRaw?.data as Float32Array;
                    doseMaxStdRaw = regionListA[geohash].doseMaxStdRaw?.data as Float32Array;
                    maskMap = regionListA[geohash].maskMap?.data as Float32Array;
                    thisRegionCombined = thisRegionA;
                    thisRegionUuid = thisRegionA.uuid;
                } else if(!thisRegionA && thisRegionB){
                    doseRaw = regionListB[geohash].doseRaw?.data as Float32Array;
                    doseStdRaw = regionListB[geohash].doseStdRaw?.data as Float32Array;
                    doseMaxRaw= regionListB[geohash].doseMaxRaw?.data as Float32Array;
                    doseMaxStdRaw = regionListB[geohash].doseMaxStdRaw?.data as Float32Array;
                    maskMap = regionListB[geohash].maskMap?.data as Float32Array;
                    thisRegionCombined = thisRegionB;
                    thisRegionUuid = thisRegionB.uuid;
                } else {
                    process_this_region = false;
                }

                if(process_this_region){
                    //console.log(doseRawDiff)
                    let thisDoseRaw:Parsed = {dtype:"float32",data:doseRaw!,shape:[500,500],fortranOrder:false};
                    let thisDoseMaxRaw:Parsed = {dtype:"float32",data:doseMaxRaw!,shape:[500,500],fortranOrder:false};
                    let thisMaskMapRaw:Parsed = {dtype:"float32",data:maskMap!,shape:[500,500],fortranOrder:false};
                    let thisDoseMapStdRaw:Parsed = {dtype:"float32",data:maskMap!,shape:[500,500],fortranOrder:false};
                    let msg1 = DoseMapUtility.MakeDoseImageMasked(thisDoseRaw,thisMaskMapRaw,-2,2)
                    let imageData1 = Buffer.from(msg1, 'base64');
                    const binaryDoseMapData = imageData1 as unknown as string;
                    let msg2 = DoseMapUtility.MakeDoseImageMasked(thisDoseMaxRaw,thisMaskMapRaw,-2,2)
                    let imageData2 = Buffer.from(msg2, 'base64');
                    const binaryDoseMaxData = imageData2 as unknown as string;

                    let thisRegion:TiledDoseMapImage = {uuid: thisRegionUuid!,
                                                        time: Date.now()/1000,
                                                        doseMap: binaryDoseMapData,
                                                        maxDoseMap: binaryDoseMaxData,
                                                        uncertMap: null,
                                                        doseRaw: thisDoseRaw,
                                                        doseMaxRaw: thisDoseMaxRaw,
                                                        maskMap: thisMaskMapRaw,
                                                        maskMax: thisMaskMapRaw,
                                                        dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                        swCorner: {lat:thisRegionCombined?.swCorner.lat!,
                                                                   lon:thisRegionCombined?.swCorner.lon!},
                                                        neCorner: {lat:thisRegionCombined?.neCorner.lat!,
                                                                   lon:thisRegionCombined?.neCorner.lon!}};

                    //Calculate data statistics
                    DoseMapUtility.updateDataStatisticsForRegion(thisRegion);

                    regionOverlap.push(thisRegion)
                    dose_map_message.regions!.push(thisRegion);
                    if(thisRegion.time !== null && (dose_map_message.lastUpdatedTime === null || dose_map_message.lastUpdatedTime < thisRegion.time)){
                        dose_map_message.lastUpdatedTime = thisRegion.time;
                    }
                }

            });
        }






        dose_map_message.lastUpdatedTime = Date.now()/1000;
        dose_map_message.regions = regionOverlap;
        //console.log(regionOverlap)
        //dose_map_message = this.updateDataStatistics(dose_map_message);
        //dose_map_message = this.updateDoseMaps(dose_map_message);
        return dose_map_message;
    }

    static updateDoseMaps(message:DoseMapMessage){
        console.log('UpdateDoseMaps: message last updated: '+(message.lastUpdatedTime === null ? 'never' : (new Date(message.lastUpdatedTime*1000).toLocaleString()+" ["+Math.round(((Date.now()/1000)-message.lastUpdatedTime)/60.0)+"m ago]")));
        const starttime = Date.now();
        let binaryDoseMapData = null;
        let binaryDoseMaxData = null
        let binaryUncertMapData = null;
        let timeUpdated = null;

        if(message.regions !== null){
            for(let i = 0; i < message.regions.length; i++) {
                //step through each region and make
                if(message.regions[i].doseRaw && message.regions[i].maskMap){
                    //console.log("doseMapMax:" + message.doseMapMax+" doseMapMin: "+message.doseMapMin)
                    let msg = this.MakeDoseImageMasked(message.regions[i].doseRaw!,message.regions[i].maskMap!,message.displayScaleVal[DoseDatatype.DOSE_RATE].max,message.displayScaleVal[DoseDatatype.DOSE_RATE].min)
                    const imageData = Buffer.from(msg, 'base64');
                    binaryDoseMapData = imageData as unknown as string;
                    message.regions[i].doseMap = binaryDoseMapData;
                }
                if(message.regions[i].doseMaxRaw && message.regions[i].maskMax){
                    //console.log("doseMaxMapMax:" + message.doseMaxMapMax+" doseMaxMapMin: "+message.doseMaxMapMin)
                    let msg = this.MakeDoseImageMasked(message.regions[i].doseMaxRaw!,message.regions[i].maskMax!,message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].max,message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].min)
                    const imageData = Buffer.from(msg, 'base64');
                    binaryDoseMaxData = imageData as unknown as string;
                    message.regions[i].maxDoseMap = binaryDoseMaxData;
                }
                if(message.regions[i].doseStdRaw && message.regions[i].maskMap){
                    //console.log("uncertMapMax:" + message.uncertMapMax+" uncertMapMin: "+message.uncertMapMin)
                    let msg = this.MakeDoseImageMasked(message.regions[i].doseStdRaw!,message.regions[i].maskMap!,message.displayScaleVal[DoseDatatype.UNCERTAINTY].max,message.displayScaleVal[DoseDatatype.UNCERTAINTY].min)
                    const imageData = Buffer.from(msg, 'base64');
                    binaryUncertMapData = imageData as unknown as string;
                    message.regions[i].uncertMap = binaryUncertMapData;
                }
            }
        }
        const endtime = Date.now();
        const elapsed = endtime - starttime;
        console.log("DOSE_RATE max:" + message.displayScaleVal[DoseDatatype.DOSE_RATE].max+" min: "+message.displayScaleVal[DoseDatatype.DOSE_RATE].min)
        console.log("DOSE_MAX max:" + message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].max+" min: "+message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].min)
        console.log("UNCERTAINTY max:" + message.displayScaleVal[DoseDatatype.UNCERTAINTY].max+" min: "+message.displayScaleVal[DoseDatatype.UNCERTAINTY].min)
        console.log('Total Map Update Elapsed Time (ms): '+elapsed)
        return message;
    }

    static MakeDoseImage(npyArray:Parsed, npyStdArray:Parsed, maxVal?:number|null, minVal?:number|null) {

            //const starttime = Date.now();
            //console.log('npyArray loaded')
            let width = npyArray.shape[0];
            let height = npyArray.shape[1];
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');

            if(minVal===undefined || minVal === null) minVal = 0.5;
            if(maxVal===undefined || maxVal===null) maxVal = 2.5;
            let numSteps = 255;

            let imgData = context!.createImageData(width, height);
            canvas.height = height;
            canvas.width = width;
            let data_in = npyArray.data as Float32Array;
            let std_data_in = npyStdArray.data as Float32Array;
            if(data_in===undefined)
                data_in = new Float32Array(500*500);
            if(std_data_in===undefined)
                std_data_in = new Float32Array(500*500);
            let normalized = DoseMapUtility.normalize(data_in,minVal,maxVal,255);
            let normalized_std = DoseMapUtility.normalize(std_data_in,0.4,0.5);

            let colors = colormap({
                colormap: 'jet',
                nshades: 256,
                format: 'rgba',
                alpha: 1
            })
            // fill imgData with colors from array
            for(let i = 0; i < normalized.length; i++) {
                // Convert pixels[i] to RGB
                // See http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
                const rgba = colors[normalized[i]]
                //if(1-normalized_std[i]>0){
                    imgData.data[4*i] = rgba[0];
                    imgData.data[4*i + 1] = rgba[1];
                    imgData.data[4*i + 2] = rgba[2];
                    imgData.data[4*i + 3] = (1-normalized_std[i])*255; // Alpha channel

            }
            // put data to context at (0, 0)
            context!.putImageData(imgData, 0, 0);
            // output image
            let img = new Image();
            img.src = canvas.toDataURL('image/png');

            let url = img.src;
            url = url.replace('data:image/png;base64,','');
            canvas.remove();
            //const endtime = Date.now();
            //const elapsed = endtime - starttime;
            //console.log('Elapsed Time (ms): '+elapsed)
            return url;
    }


    static MakeDoseImageMasked(npyArray:Parsed, npyMaskArray:Parsed, maxVal?:number|null, minVal?:number|null) {

            //const starttime = Date.now();
            //console.log('npyArray loaded')
            let width = npyArray.shape[0];
            let height = npyArray.shape[1];
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');

            if(minVal===undefined || minVal === null) minVal = 0.5;
            if(maxVal===undefined || maxVal===null) maxVal = 2.5;
            let numSteps = 255;

            let imgData = context!.createImageData(width, height);
            canvas.height = height;
            canvas.width = width;
            let data_in = npyArray.data as Float32Array;
            let mask_data_in = npyMaskArray.data as Float32Array;
            if(data_in===undefined)
                data_in = new Float32Array(500*500);
            if(mask_data_in===undefined)
                mask_data_in = new Float32Array(500*500);
            let normalized = DoseMapUtility.normalize(data_in,minVal,maxVal,255);
            //const std_data_in = npyStdArray.data as Float32Array;
            //let normalized_std = DoseMapUtility.normalize(std_data_in,0.4,0.5);
            let normalized_mask = DoseMapUtility.normalize(mask_data_in,0,1,255);

            let colors = colormap({
                colormap: 'jet',
                nshades: 256,
                format: 'rgba',
                alpha: 1
            })
            // fill imgData with colors from array
            for(let i = 0; i < normalized.length; i++) {
                // Convert pixels[i] to RGB
                // See http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
                const rgba = colors[normalized[i]]
                //if(1-normalized_std[i]>0){
                    imgData.data[4*i] = rgba[0];
                    imgData.data[4*i + 1] = rgba[1];
                    imgData.data[4*i + 2] = rgba[2];
                    imgData.data[4*i + 3] = (normalized_mask[i])*255; // Alpha channel

            }
            // put data to context at (0, 0)
            context!.putImageData(imgData, 0, 0);
            // output image
            let img = new Image();
            img.src = canvas.toDataURL('image/png');

            let url = img.src;
            url = url.replace('data:image/png;base64,','');
            canvas.remove();
            //const endtime = Date.now();
            //const elapsed = endtime - starttime;
            //console.log('Elapsed Time (ms): '+elapsed)
            return url;

    }


    static normalize(data_in:Float32Array, min_val:number, max_val:number, scale_in?:number){
        const scale = scale_in?scale_in:1;
        let inv_step = 1/(max_val - min_val);
        let data_out = new Uint8Array(data_in.length);
        for(let i = 0; i < data_in.length; i++) {
            if(data_in[i] > max_val){
                data_out[i] = scale;
            } else if (data_in[i] < min_val){
                data_out[i] = 0;
            } else {
                //data_out[i] = (data_in[i] - min_val)/(max_val-min_val)*256;
                data_out[i] = (data_in[i] - min_val)*inv_step*scale;
            }
            //console.log('i: '+i+' '+data_in[i]+i+' '+data_out[i])
        }
        return data_out;


    }

    static updateDataStatisticsForRegion(region:TiledDoseMapImage){
        const doseMapRaw = region.doseRaw;
        const maskMapRaw = region.maskMap;
        const doseMaxRaw = region.doseMaxRaw;
        const maskMaxRaw = region.maskMax;
        const doseMapStdRaw = region.doseMaxStdRaw;

        let result1 = DoseMapUtility.calculateRawDataStatistics(doseMapRaw,maskMapRaw);

        if(region.dataScaleVal[DoseDatatype.DOSE_RATE].max === null){
            region.dataScaleVal[DoseDatatype.DOSE_RATE].max = result1.max;
        } else {
            if(result1.max !== null && result1.max > region.dataScaleVal[DoseDatatype.DOSE_RATE].max!){
                region.dataScaleVal[DoseDatatype.DOSE_RATE].max = result1.max;
            }
        }
        if(region.dataScaleVal[DoseDatatype.DOSE_RATE].min === null){
            region.dataScaleVal[DoseDatatype.DOSE_RATE].min = result1.min;
        } else {
            if(result1.min !== null && result1.min < region.dataScaleVal[DoseDatatype.DOSE_RATE].min! ){
                region.dataScaleVal[DoseDatatype.DOSE_RATE].min = result1.min;
            }
        }

        let result2 = DoseMapUtility.calculateRawDataStatistics(doseMaxRaw,maskMaxRaw);
        if(region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max === null){
            region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max = result2.max;
        } else {
            if(result2.max !== null && result2.max > region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max! ){
                region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max = result2.max;
            }
        }
        if(region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min === null){
            region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min = result2.min;
        } else {
            if(result2.min !== null && result2.min < region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min! ){
                region.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min = result2.min;
            }
        }

        if(doseMapStdRaw !== undefined){
            let result3 = DoseMapUtility.calculateRawDataStatistics(doseMapStdRaw,maskMapRaw);
            if(region.dataScaleVal[DoseDatatype.UNCERTAINTY].max === null){
                region.dataScaleVal[DoseDatatype.UNCERTAINTY].max = result3.max;
            } else {
                if(result3.max !== null && result3.max > region.dataScaleVal[DoseDatatype.UNCERTAINTY].max! ){
                    region.dataScaleVal[DoseDatatype.UNCERTAINTY].max = result3.max;
                }
            }
            if(region.dataScaleVal[DoseDatatype.UNCERTAINTY].min === null){
                region.dataScaleVal[DoseDatatype.UNCERTAINTY].min = result3.min;
            } else {
                if(result3.min !== null && result3.min < region.dataScaleVal[DoseDatatype.UNCERTAINTY].min!){
                    region.dataScaleVal[DoseDatatype.UNCERTAINTY].min = result3.min;
                }
            }
        } else {
            region.dataScaleVal[DoseDatatype.UNCERTAINTY].max = null;
            region.dataScaleVal[DoseDatatype.UNCERTAINTY].min = null;
        }

    }
    static getGlobalDataMinMax(messages:(DoseMapMessage|undefined)[]){
        let doseRateMinMax:MinMaxPair = {min:null,max:null};
        let maxDoseRateMinMax:MinMaxPair = {min:null,max:null};
        let uncertainthMinMax:MinMaxPair = {min:null,max:null};
        //let newMessageA = messageA?structuredClone(messageA):undefined;
        //let newMessageB = messageB?structuredClone(messageB):undefined;
        if(messages.length>0){
            messages.forEach(message => {
                //DOSE_RATE
                if(message !== undefined){
                    if(doseRateMinMax.min === null){
                        doseRateMinMax.min = message.dataScaleVal[DoseDatatype.DOSE_RATE].min;
                    } else {
                        if(message.dataScaleVal[DoseDatatype.DOSE_RATE].min !== null){
                            if(message.dataScaleVal[DoseDatatype.DOSE_RATE].min! < doseRateMinMax.min){
                                doseRateMinMax.min = message.dataScaleVal[DoseDatatype.DOSE_RATE].min;
                            }
                        }
                    }
                    if(doseRateMinMax.max === null){
                        doseRateMinMax.max = message.dataScaleVal[DoseDatatype.DOSE_RATE].max;
                    } else {
                        if(message.dataScaleVal[DoseDatatype.DOSE_RATE].max !== null){
                            if(message.dataScaleVal[DoseDatatype.DOSE_RATE].max! > doseRateMinMax.max){
                                doseRateMinMax.max = message.dataScaleVal[DoseDatatype.DOSE_RATE].max;
                            }
                        }
                    }
                    //MAX_DOSE_RATE
                    if(maxDoseRateMinMax.min === null){
                        maxDoseRateMinMax.min = message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min;
                    } else {
                        if(message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min !== null){
                            if(message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min! < maxDoseRateMinMax.min){
                                maxDoseRateMinMax.min = message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min;
                            }
                        }
                    }
                    if(maxDoseRateMinMax.max === null){
                        maxDoseRateMinMax.max = message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max;
                    } else {
                        if(message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max !== null){
                            if(message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max! > maxDoseRateMinMax.max){
                                maxDoseRateMinMax.max = message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max;
                            }
                        }
                    }
                    //UNCERTAINTY
                    if(uncertainthMinMax.min === null){
                        uncertainthMinMax.min = message.dataScaleVal[DoseDatatype.UNCERTAINTY].min;
                    } else {
                        if(message.dataScaleVal[DoseDatatype.UNCERTAINTY].min !== null){
                            if(message.dataScaleVal[DoseDatatype.UNCERTAINTY].min! < uncertainthMinMax.min){
                                uncertainthMinMax.min = message.dataScaleVal[DoseDatatype.UNCERTAINTY].min;
                            }
                        }
                    }
                    if(uncertainthMinMax.max === null){
                        uncertainthMinMax.max = message.dataScaleVal[DoseDatatype.UNCERTAINTY].max;
                    } else {
                        if(message.dataScaleVal[DoseDatatype.UNCERTAINTY].max !== null){
                            if(message.dataScaleVal[DoseDatatype.UNCERTAINTY].max! > uncertainthMinMax.max){
                                uncertainthMinMax.max = message.dataScaleVal[DoseDatatype.UNCERTAINTY].max;
                            }
                        }
                    }
                }
            });
        }
        let result:{[doseDataType:number]:MinMaxPair} = {};
        result[DoseDatatype.DOSE_RATE] =  doseRateMinMax;
        result[DoseDatatype.MAX_DOSE_RATE] =  maxDoseRateMinMax;
        result[DoseDatatype.UNCERTAINTY] =  uncertainthMinMax;

        return result
    }

    static setDisplayMinMax(message:DoseMapMessage,newMinMax:{[doseDataType:number]:MinMaxPair}){

        //assign new max/min
        message.displayScaleVal[DoseDatatype.DOSE_RATE] = newMinMax[DoseDatatype.DOSE_RATE];
        message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE] = newMinMax[DoseDatatype.MAX_DOSE_RATE];
        message.displayScaleVal[DoseDatatype.UNCERTAINTY] = newMinMax[DoseDatatype.UNCERTAINTY];

        return message;
    }

    static resetDisplayStatisticsToData(message:DoseMapMessage|undefined, scaleOverrideByType?:{[doseDataType:number]:ScaleOverride}){
        if(message){
            console.log('resetting display scale to data statistics')
            message.displayScaleVal[DoseDatatype.DOSE_RATE].min = message.dataScaleVal[DoseDatatype.DOSE_RATE].min;
            message.displayScaleVal[DoseDatatype.DOSE_RATE].max = message.dataScaleVal[DoseDatatype.DOSE_RATE].max;
            message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].min = message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min;
            message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].max = message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max;
            message.displayScaleVal[DoseDatatype.UNCERTAINTY].min = message.dataScaleVal[DoseDatatype.UNCERTAINTY].min;
            message.displayScaleVal[DoseDatatype.UNCERTAINTY].max = message.dataScaleVal[DoseDatatype.UNCERTAINTY].max;

            if(scaleOverrideByType!==undefined){
                //console.log('scaleOverride[DoseDatatype.DOSE_RATE].minVal '+scaleOverrideByType[DoseDatatype.DOSE_RATE].minVal)
                if(scaleOverrideByType[DoseDatatype.DOSE_RATE]){
                    if(scaleOverrideByType[DoseDatatype.DOSE_RATE].min && scaleOverrideByType[DoseDatatype.DOSE_RATE].minVal !== undefined)
                        message.displayScaleVal[DoseDatatype.DOSE_RATE].min = scaleOverrideByType[DoseDatatype.DOSE_RATE].minVal!;
                    if(scaleOverrideByType[DoseDatatype.DOSE_RATE].max && scaleOverrideByType[DoseDatatype.DOSE_RATE].maxVal !== undefined)
                        message.displayScaleVal[DoseDatatype.DOSE_RATE].max = scaleOverrideByType[DoseDatatype.DOSE_RATE].maxVal!;
                }
                if(scaleOverrideByType[DoseDatatype.MAX_DOSE_RATE]){
                    if(scaleOverrideByType[DoseDatatype.MAX_DOSE_RATE].min && scaleOverrideByType[DoseDatatype.MAX_DOSE_RATE].minVal !== undefined)
                        message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].min = scaleOverrideByType[DoseDatatype.MAX_DOSE_RATE].minVal!;
                    if(scaleOverrideByType[DoseDatatype.MAX_DOSE_RATE].max && scaleOverrideByType[DoseDatatype.MAX_DOSE_RATE].maxVal !== undefined)
                        message.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].max = scaleOverrideByType[DoseDatatype.MAX_DOSE_RATE].maxVal!;
                }
                if(scaleOverrideByType[DoseDatatype.UNCERTAINTY]){
                    if(scaleOverrideByType[DoseDatatype.UNCERTAINTY].min && scaleOverrideByType[DoseDatatype.UNCERTAINTY].minVal !== undefined)
                        message.displayScaleVal[DoseDatatype.UNCERTAINTY].min = scaleOverrideByType[DoseDatatype.UNCERTAINTY].minVal!;
                    if(scaleOverrideByType[DoseDatatype.UNCERTAINTY].max && scaleOverrideByType[DoseDatatype.UNCERTAINTY].maxVal !== undefined)
                        message.displayScaleVal[DoseDatatype.UNCERTAINTY].max = scaleOverrideByType[DoseDatatype.UNCERTAINTY].maxVal!;
                }
            }
        }
    }

    static updateDataStatistics(message:DoseMapMessage){
        if(message.regions !== null){
            for(let i = 0; i < message.regions.length; i++) {

                const doseMapRaw = message.regions[i].doseRaw;
                const maskMapRaw = message.regions[i].maskMap;
                const doseMaxRaw = message.regions[i].doseMaxRaw;
                const maskMaxRaw = message.regions[i].maskMax;
                const doseMapStdRaw = message.regions[i].doseMaxStdRaw;

                let result1;
                if(message.regions[i].dataScaleVal[DoseDatatype.DOSE_RATE].max !== null && message.regions[i].dataScaleVal[DoseDatatype.DOSE_RATE].min !== null){
                    //Precalculated stat exists
                    console.log('Calc stat from region stat')
                    result1 = {max:message.regions[i].dataScaleVal[DoseDatatype.DOSE_RATE].max,min:message.regions[i].dataScaleVal[DoseDatatype.DOSE_RATE].min};
                } else {
                    //Calculate from data
                    console.log('Calc stat from data')
                    result1 = DoseMapUtility.calculateRawDataStatistics(doseMapRaw,maskMapRaw);
                }
                //Tabulate
                if(message.dataScaleVal[DoseDatatype.DOSE_RATE].max === null){
                    message.dataScaleVal[DoseDatatype.DOSE_RATE].max = result1.max;
                } else {
                    if(result1.max !== null && result1.max > message.dataScaleVal[DoseDatatype.DOSE_RATE].max!){
                        message.dataScaleVal[DoseDatatype.DOSE_RATE].max = result1.max;
                    }
                }
                if(message.dataScaleVal[DoseDatatype.DOSE_RATE].min === null){
                    message.dataScaleVal[DoseDatatype.DOSE_RATE].min = result1.min;
                } else {
                    if(result1.min !== null && result1.min < message.dataScaleVal[DoseDatatype.DOSE_RATE].min! ){
                        message.dataScaleVal[DoseDatatype.DOSE_RATE].min = result1.min;
                    }
                }


                let result2;
                if(message.regions[i].dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max !== null && message.regions[i].dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min !== null){
                    //Precalculated stat exists
                    result2 = {max:message.regions[i].dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max,min:message.regions[i].dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min};
                } else {
                    //Calculate from data
                    result2 = DoseMapUtility.calculateRawDataStatistics(doseMaxRaw,maskMaxRaw);
                }
                if(message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max === null){
                    message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max = result2.max;
                } else {
                    if(result2.max !== null && result2.max > message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max! ){
                        message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].max = result2.max;
                    }
                }
                if(message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min === null){
                    message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min = result2.min;
                } else {
                    if(result2.min !== null && result2.min < message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min! ){
                        message.dataScaleVal[DoseDatatype.MAX_DOSE_RATE].min = result2.min;
                    }
                }

                if(doseMapStdRaw !== undefined){
                    let result3;
                    if(message.regions[i].dataScaleVal[DoseDatatype.UNCERTAINTY].max !== null && message.regions[i].dataScaleVal[DoseDatatype.UNCERTAINTY].min !== null){
                        //Precalculated stat exists
                        result3 = {max:message.regions[i].dataScaleVal[DoseDatatype.UNCERTAINTY].max,min:message.regions[i].dataScaleVal[DoseDatatype.UNCERTAINTY].min};
                    } else {
                        //Calculate from data
                         result3 = DoseMapUtility.calculateRawDataStatistics(doseMapStdRaw,maskMapRaw);
                    }

                    if(message.dataScaleVal[DoseDatatype.UNCERTAINTY].max === null){
                        message.dataScaleVal[DoseDatatype.UNCERTAINTY].max = result3.max;
                    } else {
                        if(result3.max !== null && result3.max > message.dataScaleVal[DoseDatatype.UNCERTAINTY].max! ){
                            message.dataScaleVal[DoseDatatype.UNCERTAINTY].max = result3.max;
                        }
                    }
                    if(message.dataScaleVal[DoseDatatype.UNCERTAINTY].min === null){
                        message.dataScaleVal[DoseDatatype.UNCERTAINTY].min = result3.min;
                    } else {
                        if(result3.min !== null && result3.min < message.dataScaleVal[DoseDatatype.UNCERTAINTY].min!){
                            message.dataScaleVal[DoseDatatype.UNCERTAINTY].min = result3.min;
                        }
                    }
                } else {
                    message.dataScaleVal[DoseDatatype.UNCERTAINTY].max = null;
                    message.dataScaleVal[DoseDatatype.UNCERTAINTY].min = null;
                }
            }
        }

        console.log('setting data statistics')
        return message;
    }


    static calculateRawDataStatistics(npyArray:Parsed|undefined, npyMaskArray:Parsed|undefined):{max:number|null,min:number|null} {
        let min = null;
        let max = null;
        if(npyArray !== undefined && npyMaskArray !== undefined){
            let width = npyArray.shape[0];
            let height = npyArray.shape[1];
            let data_in = npyArray.data as Float32Array;
            let mask_in = npyMaskArray.data as Float32Array;
            if(data_in === undefined)
                data_in = new Float32Array(500*500);
            if(mask_in === undefined)
                mask_in = new Float32Array(500*500);
            let result = this.calculateMaxMinArrayMasked(data_in,mask_in);
            min = result.min;
            max = result.max;
        }
        return {min:min,max:max};
    }

    static calculateMaxMinArrayMasked(array:Float32Array, maskArray:Float32Array){
        let max:number|null = -1e23;
        let min:number|null = 1e23;
        let valid_result = false;
        for(let i = 0; i < array.length; i++) {
            const num = array[i];
            const mask = maskArray[i];
            if(mask > 0){
                valid_result = true;
                if (num > max) {
                    max = num;
                }
                if (num < min) {
                    min = num;
                }
            }
        }
        if(!valid_result){
            max = null;
            min = null;
        } else {
            //Round
            min = Number(min?.toFixed(2));
            max = Number(max?.toFixed(2));
        }
        return ({min: min, max:max});
    }

}
